import { getUniversalHelpers } from "../helpers";

export function isProduction() {
  return (getUniversalHelpers().app.options as any).databaseURL === "https://ollie-app-95ed8.firebaseio.com";
}

// i18n certified - complete
